import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Soluciones from "../components/Soluciones";
import Hardware from "../components/Hardware";
import Servicios from "../components/Servicios";
import Nosotros from "../components/Nosotros";
import Contacto from "../components/Contacto";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="min-h-screen bg-white font-body text-slate-800 antialiased"
    >
      <Navbar />
      <Hero />
      <Soluciones />
      <Hardware />
      <Servicios />
      <Nosotros />
      <Contacto />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
